import React, {createContext, useContext, useEffect} from "react";
import {useLocalStorage} from "../../hooks";
import {CookieBanner} from "./CookieBanner";

const CookieContext = createContext({})
export const useCookie = () => useContext(CookieContext);

export function CookieProvider({children}) {
    const [cookieConsent, setCookieConsent] = useLocalStorage("cookie-consent", false)

    useEffect(() => {
        const htmlElement = document.querySelector('html')
        if (cookieConsent) {
            htmlElement.setAttribute("data-cookie-consent", "accepted");
        } else {
            htmlElement.setAttribute("data-cookie-consent", "denied")
        }
    }, [cookieConsent]);

    function toggleCookieConsent() {
        setCookieConsent(true)
    }

    return (
        <CookieContext.Provider value={{cookieConsent, toggleCookieConsent}}>
            {children}
            {!cookieConsent && <CookieBanner />}
        </CookieContext.Provider>
    )
}
